<template>
  <div>
    <template v-if="!isEdit">
      <div class="pa-2">
        <v-layout class="text-xs-left">
          <v-flex class="form-control pa-2">{{ admin.adminid }}</v-flex>
          <v-btn fab small color="primary" depressed @click="onEdit">
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn fab small color="primary" depressed @click="$emit('onDelete')">
            <v-icon>delete</v-icon>
          </v-btn>
        </v-layout>
      </div>
    </template>
    <template v-else>
      <div class="px-2">
        <v-layout class="text-xs-left">
          <v-flex class="form-control pa-1" :class="{ 'has-error': errors.has('adminid') }">
            <template v-if="type == 'add'">
              <input
                type="text"
                class="mb-0"
                placeholder="Admin Id"
                data-vv-as="Admin Id"
                name="adminid"
                v-validate="`required`"
                v-model="admin.adminid"
              />
            </template>
            <template v-else>{{ admin.adminid }}</template>
            <span class="text-error">{{ errors.first('adminid') }}</span>
          </v-flex>
          <v-flex class="form-control pa-1" :class="{ 'has-error': errors.has('password') }">
            <template v-if="type == 'add'">
              <input
                type="password"
                class="mb-0"
                placeholder="Password"
                data-vv-as="Password"
                name="password"
                v-model="password"
              />
            </template>
            <span class="text-error">{{ errors.first('password') }}</span>
          </v-flex>

          <v-btn fab small color="primary" depressed @click="onSave">
            <v-icon>check</v-icon>
          </v-btn>
          <v-btn fab small color="primary" depressed @click="onCancel">
            <v-icon>close</v-icon>
          </v-btn>
        </v-layout>
        <!-- 
        <v-layout class="my-2">
          <v-flex>
            <div class="caption mt-2">Allow Bot Origin</div>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-text-field
              style="max-width: 250px; margin-right: 0; margin-left: auto"
              name="search"
              label="Search"
              v-model="searchBot"
              clearable
              single-line
              prepend-inner-icon="search"
              outline
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout>
        <div
          class="px-2"
          style=" border: 1px solid #eee; border-radius: 5px; overflow: auto; max-height: 200px; min-height: 200px;"
        >
          <v-layout wrap>
            <template v-for="bot in filterBot">
              <v-flex xs12 sm6 :key="bot.id">
                <v-checkbox
                  v-model="selectedBotList"
                  :label="bot.botname"
                  :value="`${bot.botorigin}`"
                  color="primary"
                  hide-details
                  @change="isDirty = true"
                ></v-checkbox>
              </v-flex>
            </template>
          </v-layout>
        </div> -->
      </div>

      <v-divider class="my-3"></v-divider>
      <div class="px-2 pb-2">
        <!-- <v-layout class="my-2">
          <v-flex>
            <div class="caption mt-2">Allow flow</div>
          </v-flex>
          <v-flex class="text-xs-right">
            <v-text-field
              style="max-width: 250px; margin-right: 0; margin-left: auto"
              name="search"
              label="Search"
              v-model="search"
              clearable
              single-line
              prepend-inner-icon="search"
              outline
              hide-details
            ></v-text-field>
          </v-flex>
        </v-layout> -->
        <div
          class="pa-2"
          style=" border: 1px solid #eee; border-radius: 5px; overflow: auto; max-height: 500px; min-height: 200px;"
        >
          <v-card v-for="(page, pindex) in items" :key="`${pindex}_${page.id}`">
            <v-card-text>
              <v-layout @click="page.showBot = !page.showBot">
                <v-flex>
                  <v-checkbox
                    class="mt-0"
                    v-model="selectedBotList"
                    :label="page.name"
                    :value="`${page.id}`"
                    color="primary"
                    hide-details
                    @change="isDirty = true"
                  ></v-checkbox>
                </v-flex>
                <v-flex shrink>
                  <v-icon>{{ page.showBot ? 'expand_less' : 'expand_more' }}</v-icon>
                </v-flex>
              </v-layout>
              <div class="mt-2" v-if="page.showBot">
                <v-card
                  class="mb-1"
                  v-for="(template, tindex) in page.children"
                  :key="`${pindex}_${page.id}_${tindex}_${template.name}`"
                >
                  <v-card-text>
                    <v-layout @click="template.showTemplate = !template.showTemplate">
                      <v-flex>
                        {{ template.name ? template.name : 'ไม่มี template' }}
                      </v-flex>
                      <v-flex shrink>
                        <v-icon>{{ template.showTemplate ? 'expand_less' : 'expand_more' }}</v-icon>
                      </v-flex>
                    </v-layout>

                    <div class="mt-2" v-if="template.showTemplate">
                      <div class="pa-2 grey lighten-5" style="border: 1px solid #eee">
                        <v-checkbox
                          class="mt-0"
                          :label="'Select All'"
                          v-model="template.selectAllTemplate"
                          color="primary"
                          hide-details
                          value="true"
                          @change="onSelectAllTemplate($event, page.id, template)"
                        ></v-checkbox>
                      </div>
                      <v-divider />
                      <v-layout wrap>
                        <template v-for="flow in template.children">
                          <v-flex
                            xs12
                            sm6
                            class="pa-2"
                            :key="`${pindex}_${page.id}_${template.name}_${flow.id}`"
                          >
                            <template v-if="flow.owneradminid == admin.adminid">
                              <v-checkbox
                                class="mt-0"
                                input-value="true"
                                readonly
                                :label="flow.flowname + ' (Owner)'"
                                color="primary"
                                hide-details
                              ></v-checkbox>
                            </template>
                            <template v-else>
                              <v-checkbox
                                class="mt-0"
                                v-model="selected"
                                :label="flow.flowname"
                                :value="`${flow.id}`"
                                color="primary"
                                hide-details
                              ></v-checkbox>
                            </template>
                          </v-flex>
                        </template>
                      </v-layout>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </v-card-text>
          </v-card>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
export default {
  props: ['value', 'flows', 'type', 'botorigin'],
  data() {
    return {
      password: '',
      admin: {
        adminid: '',
        flowidlist: ''
      },
      selected: [],
      selectedBotList: [],
      isEdit: false,
      isDirty: false,
      tree: [],
      types: [],
      search: '',
      searchBot: '',
      items: []
    }
  },
  mounted() {
    if (this.value) {
      this.admin = this.value
    } else {
      this.isEdit = true
    }
    this.cached_admin = JSON.stringify(this.admin)
    this.selected = this.admin.flowidlist.split(',')
    try {
      this.selectedBotList = this.admin.allowpageidlist.split(',')
    } catch (error) {}
    this.isDirty = false

    const children = this.botorigin.map(bot => ({
      id: bot.botorigin,
      name: bot.botname,
      children: this.getTemplateChildren(bot),
      showBot: false
    }))

    this.items = [...children]
  },
  computed: {
    filterBot() {
      let botorigin = this.botorigin
      if (this.searchBot) {
        botorigin = botorigin.filter(el => {
          return el.botname && el.botname.toLowerCase().includes(this.searchBot.toLowerCase())
        })
      }
      return botorigin
    }
  },
  methods: {
    onSelectAllTemplate(val, page, template) {
      let selected = cloneDeep(this.selected)

      if (val == 'true') {
        template.children.forEach(el => {
          let index = selected.indexOf(el.id.toString())
          if (index == -1) selected.push(el.id.toString())
        })
      } else {
        template.children.forEach(el => {
          let index = selected.indexOf(el.id.toString())
          if (index != -1) selected.splice(index, 1)
        })
      }

      this.selected = cloneDeep(selected)
    },
    getTemplateChildren(bot) {
      var template = this.flows
        .filter(el => el.pageidlist && el.pageidlist.includes(bot.botorigin))
        .map(el => {
          if (el.template) return el.template
          else return null
        })
      let temp = template
        .filter((v, i) => template.indexOf(v) === i)
        .sort((a, b) => {
          if (a === b) return 0
          else if (a == null) return 1
          else if (b == null) return -1
          else a < b ? -1 : 1
        })

      return temp.map(type => ({
        id: type,
        name: this.getName(type),
        children: this.getChildren(bot, type),
        selectAllTemplate: null,
        showTemplate: false
      }))
    },
    getChildren(bot, type) {
      let flows = []
      // template
      try {
        let flow_list = this.flows.filter(
          el => el.pageidlist && el.pageidlist.includes(bot.botorigin) && el.template === type
        )

        flows = flow_list.map(flow => ({
          ...flow,
          name: flow.flowname,
          id: flow.id
        }))
      } catch (error) {
        console.error(error)
      }

      return flows.sort((a, b) => {
        return a.name > b.name ? 1 : -1
      })
    },
    getName(name) {
      if (!name) return null
      return `${name.charAt(0).toUpperCase()}${name.slice(1)}`
    },
    onSave() {
      var vm = this
      vm.$validator.validateAll().then(result => {
        if (!result) {
          vm.goToErrorInput()
          // do stuff if not valid.
          // console.log(this.$validator.errors.items)
          return false
        }

        var selected = vm.selected.filter(el => {
          return el != ''
        })

        var selectedBotList = vm.selectedBotList.filter(el => {
          return el != ''
        })

        var data = {
          adminid: vm.admin.adminid,
          flowidlist: selected.join(','),
          allowpageidlist: selectedBotList.join(','),
          password: vm.password
        }

        vm.$emit('onSave', { data: data, isLogout: vm.isDirty })
        vm.admin = data
        vm.cached_admin = JSON.stringify(data)
        vm.isEdit = false
        vm.isDirty = false
      })
    },
    onCancel() {
      this.isEdit = false
      this.$emit('onCancel')
      this.admin = JSON.parse(this.cached_admin)
      this.selected = this.admin.flowidlist.split(',')
      this.selectedBotList = this.admin.allowpageidlist.split(',')
      this.isDirty = false
    },
    onEdit() {
      this.isEdit = true
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/allbots/AddAdmin.vue